import { DefaultTable } from "../shared";
import DeleteTierCourse from "./DeleteTierCourse";
import AddCourseToTier from "./AddCourseToTier";
import { useState } from "react";

interface CourseObject {
    id: string;
    name: string;
    tierCourseId: string;
}

interface ManageTierCoursesProps {
    tierId: string;
    tierName: string;
    tierCountry: string;
    courses: CourseObject[];
}

const ManageTierCourses = ({ tierId, tierName, courses, tierCountry }: ManageTierCoursesProps) => {
    const [showAddCourse, setShowAddCourse] = useState(false);
    const getManageCoursesActions = (courseID: string) => {
        const selectedCourseDetails = courses.find(({ id }) => id === courseID);
        return <DeleteTierCourse tierCourseID={selectedCourseDetails?.tierCourseId ?? ""} />;
    };

    return (
        <>
            {!showAddCourse ? (
                <div className="d-flex justify-content-end mb-3">
                    <button
                        className="btn btn-outline-primary"
                        onClick={(e) => {
                            e.preventDefault();
                            setShowAddCourse(true);
                        }}
                    >
                        Add Course
                    </button>
                </div>
            ) : (
                <div className="card mb-4">
                    <div className="card-header">
                        <h5 className="mb-0">Add Courses</h5>
                    </div>
                    <div className="card-body">
                        <AddCourseToTier tierId={tierId} tierCountry={tierCountry} />
                    </div>
                </div>
            )}

            <div className="card">
                <div className="card-header">
                    <h5 className="mb-0">List of Courses</h5>
                </div>
                <div className="card-body">
                    {courses.length > 0 ? (
                        <div className="mb-4">
                            <DefaultTable
                                data={courses}
                                headers={[
                                    {
                                        accessorKey: "id",
                                        header: "ID",
                                    },
                                    {
                                        accessorKey: "name",
                                        header: "Title",
                                    },
                                    {
                                        accessorKey: "",
                                        header: "Actions",
                                        cell: ({ row }: any) =>
                                            getManageCoursesActions(row.getValue("id") ?? ""),
                                    },
                                ]}
                            />
                        </div>
                    ) : (
                        <p className="text-danger mb-0">
                            Currently, there are no courses assigned to this tier.
                        </p>
                    )}
                </div>
            </div>
        </>
    );
};

export default ManageTierCourses;
